import React from "react";
import "./App.css";
import Header from "./Components/Header/Header";
import Register from "./Components/Pages/Register";

export default function App() {
    return (
        <div className=" backdrop-blur-lg bg-opacity-50  dark:text-slate-300  duration-100 ease-in-out">
            {/* header of app */}
            <Header />
            {/* Register page */}
            <Register />
        </div>
    );
}
